import stores from './stores.json';

export type StoreConfig = {
  id: string;
  name: string;
  subdomain: string;
  hotline?: string;
  hotlineLink?: string;
};

const storeConfigs = stores as StoreConfig[];

export function getSubdomainFromHost(hostname: string): string | null {
  const parts = hostname.split('.');
  console.log('parts', parts);
  if (parts.length < 2) {
    return null;
  }
  return parts[0];
}

export function getCurrentStoreConfig(): StoreConfig | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const subdomain = getSubdomainFromHost(window.location.hostname);
  if (subdomain) {
    const normalizedSubdomain = subdomain.toLowerCase();
    const matchedStore = storeConfigs.find(
      (store) => store.subdomain.toLowerCase() === normalizedSubdomain
    );
    console.log('matchedStore', matchedStore);
    if (matchedStore) {
      return matchedStore;
    }
  }


  const envStoreId = process.env.REACT_APP_STORE_ID;
  if (envStoreId) {
    const envStore = storeConfigs.find((store) => store.id === envStoreId);
    if (envStore) {
      return envStore;
    }
  }
  return null;
}
